<script setup>
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Methods ---

const openThemesEditorAddModal = () => {
    store.dispatch('modals/show', {
        componentName: 'ThemesEditorAddModal',
        obj: {
            id: 0,
        }
    });
};
</script>

<template>
    <button class="dropdown-item d-flex align-items-center" type="button" @click="openThemesEditorAddModal">
        <i class="me-2 bi-plus-lg"/>
        New
    </button>
</template>